/* Stage E (ux-flow.md): the check. Where almost every visit starts, so index.html preloads
   this chunk next to the entry (vite.config.ts). */
import { registerMessages } from '../../i18n';
import S0bMessages from '../../i18n/en/S0b';
import S1Messages from '../../i18n/en/S1';
import S2Messages from '../../i18n/en/S2';
import S3Messages from '../../i18n/en/S3';
import S3manualMessages from '../../i18n/en/S3-manual';
import S4Messages from '../../i18n/en/S4';
import S5Messages from '../../i18n/en/S5';
import S6Messages from '../../i18n/en/S6';
import S6stopMessages from '../../i18n/en/S6-stop';

registerMessages({
  S0b: S0bMessages,
  S1: S1Messages,
  S2: S2Messages,
  S3: S3Messages,
  'S3-manual': S3manualMessages,
  S4: S4Messages,
  S5: S5Messages,
  S6: S6Messages,
  'S6-stop': S6stopMessages,
});

export { default as S0b } from '../../screens/S0b';
export { default as S1 } from '../../screens/S1';
export { default as S2 } from '../../screens/S2';
export { default as S3 } from '../../screens/S3';
export { default as S4 } from '../../screens/S4';
export { default as S5 } from '../../screens/S5';
export { default as S6 } from '../../screens/S6';
export { default as S6stop } from '../../screens/S6-stop';
